import * as Charts from './chart';

let frappe     = { };

frappe.NAME    = 'Frappe Charts';
frappe.VERSION = '1.1.0';

frappe         = Object.assign({ }, frappe, Charts);

export default frappe;